module.exports = __webpack_public_path__ + "static/media/portfolio-06 copy.b32b52df.jpg";